import { GetAuthToken, useAuth } from '@domain/auth/AuthContext';
import { AsyncQueryResult, useAsyncQuery } from '@hooks/useAsyncQuery';

/**
 * This hook can be used for sending rest requests to Rutilus. It works in a similar way to Apollo's
 * useQuery hook, returning an isLoading value, and a data value once the request is complete. It
 * only runs client side (we have no way currently to pass REST fetched data from the server to the
 * client like we do with graphQL).
 */
export function useRutilusRestQuery<Response, Variables>(
  queryFunction: (
    variables: Variables,
    getAuthToken: GetAuthToken,
    signal: AbortSignal,
  ) => Promise<Response>,
  variables: Variables,
  { skip = false }: { skip?: boolean },
): AsyncQueryResult<Response> {
  const { getToken } = useAuth();

  // The variables obj is a fresh object each render, so it is stringified to key the request.
  return useAsyncQuery(skip ? null : JSON.stringify(variables), async signal =>
    queryFunction(variables, getToken, signal),
  );
}
